import notFoundImage from "../assets/not-found.webp";

export default function NotFound() {
    return (
        <div className="ae-page-container ae-not-found-page -fade-in">
            <h1>Sorry</h1>
            <h3>The page you're looking for doesn't exist.<br/>
            You may have mistyped the address or the page may have moved.
            </h3>
            <a className="ae-link b" href="/">Go to homepage →</a>
            <img className="ae-not-found-image" src={notFoundImage} alt=""/>
        </div>
    )
}